import { render, staticRenderFns } from "./AdminMailingsListView.vue?vue&type=template&id=bbae50d6&scoped=true"
import script from "./AdminMailingsListView.vue?vue&type=script&lang=js"
export * from "./AdminMailingsListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbae50d6",
  null
  
)

export default component.exports